import React, { useState, useMemo } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { companyProfile } from '../content/siteContent';
import { servicesData } from '../content/servicesData';

function Header() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const featuredServices = useMemo(() => servicesData.slice(0, 4), []);
  const isServicesActive =
    location.pathname === '/services' || location.pathname.startsWith('/services/');

  React.useEffect(() => {
    setIsServicesOpen(false);
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  if (isHomePage) {
    return (
      <header className="hdr hdr--home">
        <div className="hdr__home-inner">
          <Link to="/" className="hdr__home-logo" aria-label="Vedanskrix home">
            <img src="/logo.jpg" alt="Vedanskrix logo" />
          </Link>
        </div>
      </header>
    );
  }

  return (
    <header className="hdr">
      {/* ── Top bar ── */}
      <div className="hdr__topbar">
        <div className="hdr__topbar-inner">
          <span className="hdr__topbar-item">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 7 10 7 10-7"/></svg>
            <a href={`mailto:${companyProfile.primaryEmail}`}>{companyProfile.primaryEmail}</a>
          </span>
          <span className="hdr__topbar-loc">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
            {companyProfile.location}
          </span>
        </div>
      </div>

      {/* ── Main header ── */}
      <div className="hdr__main">
        <div className="hdr__main-inner">
          {/* Brand */}
          <Link to="/" className="hdr__brand">
            <img src="/logo.jpg" alt="Vedanskrix logo" className="hdr__brand-logo" />
            <div className="hdr__brand-text">
              <span className="hdr__brand-legal">{companyProfile.legalName}</span>
              <span className="hdr__brand-name">{companyProfile.brandName}</span>
              <span className="hdr__brand-tag">{companyProfile.tagline}</span>
            </div>
          </Link>

          {/* Mobile toggle */}
          <button
            type="button"
            className={isMobileMenuOpen ? 'hdr__toggle active' : 'hdr__toggle'}
            aria-expanded={isMobileMenuOpen}
            aria-label="Toggle menu"
            onClick={() => setIsMobileMenuOpen(v => !v)}
          >
            <span /><span /><span />
          </button>
        </div>
      </div>

      {/* ── Nav bar ── */}
      <nav className="hdr__nav" aria-label="Primary navigation">
        <div className={isMobileMenuOpen ? 'hdr__nav-inner open' : 'hdr__nav-inner'}>
          <NavLink to="/" end className={({isActive}) => isActive ? 'hdr__link active' : 'hdr__link'}>Home</NavLink>
          <NavLink to="/about" className={({isActive}) => isActive ? 'hdr__link active' : 'hdr__link'}>About</NavLink>
          <NavLink to="/our-work" className={({isActive}) => isActive ? 'hdr__link active' : 'hdr__link'}>Our Work</NavLink>

          {/* Services dropdown */}
          <div
            className="hdr__dropdown-wrap"
            onMouseEnter={() => setIsServicesOpen(true)}
            onMouseLeave={() => setIsServicesOpen(false)}
          >
            <button
              type="button"
              className={isServicesActive ? 'hdr__link hdr__link--drop active' : 'hdr__link hdr__link--drop'}
              onClick={() => setIsServicesOpen(v => !v)}
              aria-expanded={isServicesOpen}
            >
              Services <span className="hdr__caret" aria-hidden="true">▾</span>
            </button>
            <div className={isServicesOpen ? 'hdr__dropdown open' : 'hdr__dropdown'}>
              <div className="hdr__dropdown-grid">
                {servicesData.map(s => (
                  <Link
                    key={s.slug}
                    to={`/services/${s.slug}`}
                    className="hdr__dropdown-item"
                    onClick={() => { setIsServicesOpen(false); setIsMobileMenuOpen(false); }}
                  >
                    <strong>{s.menuLabel}</strong>
                    <span>{s.homeDescription}</span>
                  </Link>
                ))}
              </div>
              <div className="hdr__dropdown-aside">
                <p className="hdr__dropdown-aside-label">Quick Access</p>
                <div className="hdr__dropdown-tags">
                  {featuredServices.map(s => (
                    <Link
                      key={s.slug}
                      to={`/services/${s.slug}`}
                      className="hdr__dropdown-tag"
                      onClick={() => { setIsServicesOpen(false); setIsMobileMenuOpen(false); }}
                    >{s.shortTitle}</Link>
                  ))}
                </div>
                <Link to="/services" className="hdr__dropdown-all" onClick={() => { setIsServicesOpen(false); setIsMobileMenuOpen(false); }}>
                  View All Services →
                </Link>
              </div>
            </div>
          </div>

          <NavLink to="/contact" className={({isActive}) => isActive ? 'hdr__link active' : 'hdr__link'}>Contact</NavLink>

          <a href={`tel:${companyProfile.phone}`} className="hdr__cta">
            Call Us Now
          </a>
        </div>
      </nav>
    </header>
  );
}

export default Header;
